<template>
<div class="product-inventory-section">
	<div class="py-3">
		<div class="row">
			<!-- Stock management -->
			<div class="col-12">
				<div class="form-group mb-2 d-flex justify-content-between">
					<div>
						<label class="">
							<span class="text-bold">{{ $t("Stock Management") }}</span>
							<i
								class="material-icons info"
								v-tooltip="$t('Set the number of product stock')">
								info
							</i>
							<br />
							<span>{{ $t("Set the amount of stock in your store") }}</span>
						</label>
					</div>
					<label class="d-block">
						<checkbox-toggle
							:label="isStockEnabled ? $t('Active') : $t('Not Active')"
							:value="isStockEnabled"
							:disabled="!isToggleStockEnabled"
							@input="val => toggle(val, 'stock')"
						/>
					</label>
				</div>
			</div>
			<!-- Multiwarehouse -->
			<div class="col-12">
				<div class="form-group mb-2 d-flex justify-content-between">
					<div class="w-75">
						<span class="text-bold">{{ $t("Multi Warehouse") }}</span>
						<i
							class="material-icons info"
							v-tooltip="$t('Setting Multi Warehouse')">
							info
						</i>
						<br />
						<span>{{ $t("Warehouse management to be displayed to buyers based on the closest distance or cheapest shipping automatically.") }}</span>
					</div>
					<label class="d-block">
						<checkbox-toggle
							:label="isMultiWarehouse ? $t('Active') : $t('Not Active')"
							:value="isMultiWarehouse"
							@input="val => toggle(val, 'setting')"
						/>
					</label>
				</div>
			</div>
			<!-- Multi warehouse section -->
			<multiwarehouse-section
				v-if="isMultiWarehouse"
				@change-type="changeWarehouseType"
				:selected-type="multiWarehouseType"
				:product="product"
				:product-id="productId"
				:is-edit-product="isEditProduct"
			/>
			<div v-if="isStockEnabled" class="col-12 row border-t">
				<!-- Backorder -->
				<!-- Hidden by Request -->
				<div class="col-12 hidden">
					<div class="row">
						<div class="col-12 my-4">
							<span class="text-bold">{{ $t('Allow Backorders') }}</span>
						</div>

						<div class="col-md-6">
							<span class="">
								{{ $t('If it is allowed, then the buyer can still order goods even though the stock has run out.') }}
							</span>
						</div>
						<div class="col-md-6">
							<select
								name="allow_backorder"
								class="form-control"
								v-model="backorder"
								@change="setStock">
								<option :value="1">{{ $t("Allow") }}</option>
								<option :value="0">{{ $t("Do not allow") }}</option>
							</select>
						</div>
					</div>
				</div>

				<!-- Not Warehouse -->
				<template v-if="!isMultiWarehouse">
					<!-- Variable Product's Stocks -->
					<div class="col-12 mt-3">
						<div
							class="form-group"
							v-if="isProductTypeVariable">
							<label><b>{{ $t('Stock Quantities') }}</b></label>
							<div class="variable-item-stocks">
								<div
									class="variable-item-stock"
									v-for="(variation, index) in productVariations"
									:key="index">
									<div class="variable-item-stock-name">
										{{ variation.name.split('||').join(' - ') }}
									</div>
									<div>
										<div class="input-group">
											<input
												type="number"
												class="input form-control"
												:class="{
													disabled: isInputAvalaible(variation),
												}"
												min="0"
												:value="variation.stock.quantity"
												:disabled="isInputAvalaible(variation)"
												@change="inputQuantityStock($event, 'variable', index)"
											/>
											<div
												class="input-group-append"
												v-if="isInputAvalaible(variation)"
											>
												<button
													type="button"
													class="pc-stock-edit btn btn-default btn-icon"
													v-tooltip="$t('Adjust Stock')"
													@click="setQuantityStock(variation.name, 'sync', variation.stock.quantity)">
													<i class="material-icons text-info">edit</i>
												</button>
												<button
													type="button"
													class="pc-stock-edit btn btn-default btn-icon"
													v-tooltip="$t('Reduce Stock')"
													@click="setQuantityStock(variation.name, 'decrease')">
													<i class="material-icons text-danger">remove</i>
												</button>
												<button
													type="button"
													class="pc-stock-edit btn btn-default btn-icon"
													v-tooltip="$t('Add Stock')"
													@click="setQuantityStock(variation.name, 'increase')">
													<i class="material-icons text-success">add</i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Simple -->
					<div v-if="isProductTypeSimple" class="col-12 mt-3">
						<div class="form-group">
							<label><b>{{ $t('Stock Quantity') }}</b></label>
							<div class="input-group">
								<input
									type="number"
									min="0"
									class="input form-control"
									:value="stockQuantity"
									:disabled="isEditProduct"
									@change="inputQuantityStock($event, 'simple')"
								/>
								<div class="input-group-append" v-if="isEditProduct">
									<button
										type="button"
										class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="$t('Adjust Stock')"
										@click="setQuantityStock('' ,'sync', stockQuantity)">
										<i class="material-icons text-info">edit</i>
									</button>
									<button
										type="button"
										class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="$t('Reduce Stock')"
										@click="setQuantityStock('', 'decrease')">
										<i class="material-icons text-danger">remove</i>
									</button>
									<button
										type="button"
										class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="$t('Add Stock')"
										@click="setQuantityStock('', 'increase')">
										<i class="material-icons text-success">add</i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</template>

			</div>
			<!-- Stock Status -->
			<template v-if="!isStockEnabled && !isMultiWarehouse">
				<div class="col-md-12 border-t">
					<div class="form-group mt-2">
					<label>
						<b>{{ $t("Stock Status") }}</b>
					</label>
					<select
						name="stock_status"
						class="form-control"
						@change="setStock"
						v-model="stockStatus">
						<option :value="1">{{ $t("In Stock") }}</option>
						<option :value="0">{{ $t("Out of Stock") }}</option>
					</select>
				</div>
				</div>
			</template>
		</div>
	</div>
	<div class="modals">
		<update-stock
			v-if="showModalUpdateStock"
			formType="single"
			:stock="quantity"
			:type="typeModal"
			:stockVariant="stockVariation"
			:productId="productId"
			:product="product"
			@close="showModalUpdateStock = false"
			@set-stock="setQuantity"
			@update-variations="updateVariationPricesStock"
		/>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CheckboxToggle from '@/components/CheckboxToggle.vue';
import MultiwarehouseSection from '@/components/products/new-inventory/section/MultiwarehouseSection.vue';
import userApi from '@/api/user';
import UpdateStock from './section/modal/UpdateStock.vue';
import { duplicateVar, getAxiosErrorMessage } from '@/lib/helper';

const listAction = [
	{
		icon: 'edit_note',
		key: 'sync',
		text: 'Adjust Stock',
		class: 'text-primary',
	},
	{
		icon: 'add',
		key: 'increase',
		text: 'Add Stock',
		class: 'text-success',
	},
	{
		icon: 'remove',
		key: 'decrease',
		text: 'Reduce Stock',
		class: 'text-danger',
	},
];

const btnActions = [
	{
		icon: 'edit_note',
		class: 'text-primary',
	},
	{
		icon: 'add',
		class: 'text-success',
	},
	{
		icon: 'remove',
		class: 'text-danger',
	},
];

const optionAllow = [
	{
		label: 'Allow',
		key: 'allow',
	},
	{
		label: 'Disallow',
		key: 'disallow',
	},
];

export default {
	name: 'NewInventorySection',
	props: {
		product: {
			type: Object,
			required: true,
		},
		isEditProduct: {
			type: Boolean,
			required: false,
		},
		isOutsourceProduct: {
			type: Boolean,
			default: false,
		},
		savedProductId: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		// isLoadingToogle: false,
		isStockEnabled: true, // default true
		stockQuantity: 0,
		isMultiWarehouse: false,
		multiWarehouseType: 'nearest',
		backorder: 0,
		stockStatus: 1,
		stockVariation: '',
		btnActions,
		optionAllow,
		typeModal: '',
		listAction,
		showModalUpdateStock: false,
		quantity: 0,
		maxLength: 7,
	}),
	components: {
		CheckboxToggle,
		MultiwarehouseSection,
		UpdateStock,
	},
	watch: {
		// isMultiWarehouse() {
		// 	this.setStock();
		// },
		// multiWarehouseType() {
		// 	this.setStock();
		// },
		// isStockEnabled() {
		// 	this.setStock();
		// },
		// dataProduct() {
		// 	this.update();
		// },
	},
	computed: {
		...mapGetters({
			productData: 'productCreator/productData',
		}),
		productId() {
			// return this.$route.params.id;
			let id = '';
			if (this.isEditProduct) {
				id = this.$route.params.id;
			} else {
				// id = this.productData ? this.productData._id : '';
				id = this.savedProductId;
			}
			return id;
		},
		productType() {
			return this.product.type;
		},
		productVariations() {
			return this.product?.variations?.prices ?? [];
		},
		isProductTypeVariable() {
			return this.productType === 'variable';
		},
		isProductTypeSimple() {
			return this.productType === 'simple';
		},
		isToggleStockEnabled() {
			// force enable stock management
			return false;
		},
	},
	created() {
		if (!this.isEditProduct) {
			this.fetchSettingUserConfiguration();
		} else {
			this.handleProduct();
		}
	},
	methods: {
		...mapActions({
			setStockProduct: 'productWarehouse/setStock',
			setProductType: 'productWarehouse/setProductType',
			setVariants: 'productWarehouse/setVariants',
			setProductVariant: 'productCreator/setProductVariant',
			inputProductVariantPrice: 'productCreator/inputProductVariantPrice',
		}),
		handleProduct() {
			const stock = this.product?.stock ?? null;
			this.stockQuantity = stock?.quantity ?? 0;
			this.isStockEnabled = stock?.enabled ?? false;
			this.stockStatus = stock?.status ?? 1;
			this.backorder = stock?.backorder ?? 1;
			// eslint-disable-next-line camelcase
			this.isMultiWarehouse = stock?.multi_warehouse ?? false;
			// eslint-disable-next-line camelcase
			this.multiWarehouseType = stock?.multi_warehouse_type ?? 'nearest';

			const type = this.product?.type ?? 'simple';
			this.setProductType(type);
		},
		toggle(val, type = '') {
			const productData = duplicateVar(this.product);
			if (type === 'stock') {
				this.isStockEnabled = val;
				productData.stock.enabled = val;
			} else {
				this.isMultiWarehouse = val;
				productData.stock.multi_warehouse = val;
			}
			this.update(productData);
			this.setStock();
		},
		setStock() {
			let productData = duplicateVar(this.product);
			const stock = {
				...productData.stock,
				enabled: this.isStockEnabled,
				quantity: this.stockQuantity,
				status: this.stockStatus,
				backorder: this.backorder,
				multi_warehouse: this.isMultiWarehouse,
				multi_warehouse_type: this.multiWarehouseType,
			};
			productData = {
				...productData,
				stock,
			};
			this.update(productData);
			this.setStockProduct(stock);
		},

		openModalUpdateStock(key) {
			this.typeModal = key;
			this.quantity = key === 'sync' ? this.stock?.quantity ?? 0 : 0;
			this.showModalUpdateStock = true;
		},

		isInputAvalaible(variation) {
			return this.isEditProduct && !this.isNewVariation(variation.name);
		},
		setQuantity(quantity) {
			this.stockQuantity = quantity ?? 0;
		},
		changeWarehouseType(type) {
			const productData = duplicateVar(this.product);
			this.multiWarehouseType = type;
			productData.stock.multi_warehouse_type = type;
			this.update(productData);
		},
		setProductWarehouse(enabled, type) {
			const productData = duplicateVar(this.product);
			this.isMultiWarehouse = enabled;
			this.multiWarehouseType = type;

			productData.stock.multi_warehouse = enabled;
			productData.stock.multi_warehouse_type = type;
			this.update(productData);
		},
		fetchSettingUserConfiguration() {
			const callback = (responses) => {
				if (responses?.data?.length > 0) {
					const warehouseSetting = responses.data.filter(item => item.key === 'warehouse').map(curr => curr.value);
					const multiWarehouse = !!warehouseSetting[0].enabled;
					const multiWarehouseType = warehouseSetting[0].shipping_type;

					this.setProductWarehouse(multiWarehouse, multiWarehouseType);
				}
			};
			const err = (e) => {
				// console.log(e);
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'productCreator',
					title: 'Get User Setting',
					text: message,
					type: 'error',
				});
			};
			userApi.getUserSetting({}, callback, err);
		},
		/**
		* Show Quantity Update stock popup
		*
		* @param {variant} variant Variant Quantity
		* @param {String} typeModal Type Modal.
		*/
		setQuantityStock(variation = '', typeModal = '', stock = null) {
			this.typeModal = typeModal ?? '';
			this.stockVariation = variation ?? '';
			this.showModalUpdateStock = true;
			this.quantity = stock ?? 0;
		},
		isNewVariation(variationName) {
			const prices = this.productData.variations.prices;
			const variations = prices.filter(price => price.name === variationName);
			return variations.length === 0;
		},
		/**
		 * Update Variation Prices Stock
		 * @param {VariationPrice[]} prices Variations Prices
		 */
		updateVariationPricesStock(prices) {
			const finalProductPrice = this.product?.variations?.prices ?? [];
			if (finalProductPrice.length > 0) {
				finalProductPrice.map((curr) => {
					const sIndex = prices.findIndex(price => price.name === curr.name);
					const price = prices[sIndex];
					curr.stock.quantity = price.stock.quantity;
					return curr;
				});
			}
		},

		inputQuantityStock(e, type, index) {
			const value = e.target.value;
			const productData = duplicateVar(this.product);
			if (type === 'variable') {
				productData.variations.prices[index].stock.quantity = e.target.value;
			} else {
				productData.stock.quantity = value;
				this.setQuantity(value);
			}

			this.update(productData);
		},
		update(product) {
			this.$emit('update', product);
		},
	},
};
</script>

<style lang="scss">
.product-inventory-section {
	.btn-actions {
		background: #e9ecef;
	}

	.form-group {
		margin-bottom: 0;
	}

	.warehouse__icon {
		font-size: 30px;
	}

	.bg-gray {
		background-color: #e1eaef;
	}

	.box-padding {
		padding: 25px;
		height: 120px;
	}

	.btn-rounded {
		border-radius: 100%;
		background: #e1eaef;
		margin: 0 0 0 10px;
		/* padding: 10px; */
	}

	.btn-icon {
		color: #21252999;
		font-size: 13px;
	}
	.border-t {
		border-top: 1px solid #dddd;
		margin: 12px 0 0 0;
	}
}
</style>
